<template>
    <b-overlay :show="isRequesting" :opacity="0.4">
        <form v-if="!isEmailValid" class="register-form" @submit.prevent="processEmailCheckRequest" @paste.prevent="" method="post">
            <div class="img-container">
                <img src="img/padlock.png"/> 
            </div>
            <h2 class="register-form__title text-center" id="form-entry">{{ TEXTS.render(`FORGOT_PASSWORD_FORM_HEADER`) }}</h2>
            <br>
            <div class="text-center"><router-link to="/"> {{ TEXTS.render(`FORGOT_PASSWORD_FORM_LOGIN_LINK`) }}</router-link></div>
            <br>
            <p class="text-danger font-sm text-center mt-1 text-danger font-weight-bold" v-show="error" role="alert" v-html="error"></p>
            <EmailVerificationPrompt ref="emailVerifPrompt" v-bind:emailAddress="details.email"/>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold mb-1" for="details-email">{{ TEXTS.render(`FORGOT_PASSWORD_FORM_EMAIL_HEADER`) }}</label>
                        <input id="details-email" type="text" class="form-control skiptranslate" v-model="details.email" :placeholder="TEXTS.render(`FORGOT_PASSWORD_FORM_EMAIL_PLACEHOLDER`)">
                        <div class="register-form__validation mt-1 text-danger font-weight-bold" role="alert" v-html="validations.email" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <ColoredButton :disabled="isRequesting">{{ TEXTS.render(`FORGOT_PASSWORD_FORM_BTN_SUBMIT`) }}</ColoredButton>
                </div>
            </div>
        </form>
        <form v-else class="register-form center">
            <!-- v-if="isEmailValid" -->
            <div class="img-container">
                <img alt="" src="img/padlock.png"/> 
            </div>
            <h2 class="register-form__title text-center" role="status">{{ TEXTS.render(`FORGOT_PASSWORD_RECOVERY_EMAIL_SENT`) }}</h2>
            <p class="text-danger font-sm font-weight-bold text-center" role="alert" v-html="error"></p>
            <EmailVerificationPrompt v-bind:emailAddress="this.details.email"/>
            <p class="font-sm font-weight-bold text-center" role="status">{{ TEXTS.render(`FORGOT_PASSWORD_RECOVERY_EMAIL_NOTE`, null, {detailsEmail : details.email}) }}
                <br>
                <a href="#" v-on:click="resetEmailCheckRequest" class="link" role="status">{{ TEXTS.render(`FORGOT_PASSWORD_RECOVERY_RESEND`) }}</a>
            </p>
        </form>
    </b-overlay>
</template>

<script>
    import helper from '../../../../helper';
    import LoaderCircle from '../../../../common/components/LoaderCircle';
    import ColoredButton from '../../../../common/components/ColoredButton';
    import EmailVerificationPrompt from './EmailVerificiationPrompt'
    import Texts from '../../../../common/utils/Texts'
    import RegistrationForm from '../../../../common/mixins/RegistrationForm';
    export default {
        mixins: [RegistrationForm],
        components: {
            LoaderCircle,
            ColoredButton,
            EmailVerificationPrompt
        },
        data() {
            return {
                csoEnabled: localStorage.csoEnabled,
                details: {
                    email: ''
                },
                validations: {
                    email: '',
                    valid: true
                },

                isRequesting : false
            }
        },
        methods: {
            processEmailCheckRequest(event) {
                if(this.$refs.emailVerifPrompt){
                    this.$refs.emailVerifPrompt.clear()
                }
                this.validate();
                this.resetEmailCheckRequest();
                if (this.validations.valid) {
                    // Do API request
                    
                    this.$store.dispatch('validateEmail', this.details.email);
                    var self = this;
                    setTimeout(() => {
                        self.isRequesting = true
                    }, 100);
                }
            },
            resetEmailCheckRequest(){
                this.$store.dispatch('clearValidateEmailError');
                this.$store.dispatch('clearValidateEmailResult');
            },
            resetValidation() {
                for (const key in this.validations) {
                    if (this.validations.hasOwnProperty(key)) {
                        if (typeof key === 'string') {
                            this.validations[key] = '';
                            continue;
                        }
                    }
                }
                this.validations.valid = true;
            },
            validate(event) {
                this.resetValidation();
                if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.details.email)) || !(/^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,10})+$/.test(this.details.email))) {
                    this.validations.valid = false;
                    this.validations.email = Texts.render(`FORGOT_PASSWORD_FORM_VALIDATION_EMAIL`);
                }
            }
        },
        mounted() {
            this.resetEmailCheckRequest();
            localStorage.csoEnabled = this.$route.query && this.$route.query.cso === 'true' ? 'true' : 'false';
            this.csoEnabled = localStorage.csoEnabled;
        },
        computed: {
            TEXTS: ()=>Texts,
            loading() {
                return this.$store.getters['GET_PAGE_LOADING'];
            },
            error() {
                var error = this.$store.getters.GET_VALIDATE_EMAIL_ERROR;
                if(error == 'Your account is still pending for activation. Please check your email inbox.'){
                    // Unverified EMail
                    if(this.$refs.emailVerifPrompt){
                        this.$refs.emailVerifPrompt.show()
                        error = null
                    }
                }
                error = helper.reformatErrorMessage(error, 404, 'There was an error encountered while processing your request. Please try again. (Status code: 500)')
                this.isRequesting = false;
                helper.scrollToTop('form-entry');
                return error;
            },
            isEmailValid(){ 
                var result = this.$store.getters.GET_VALIDATE_EMAIL_RESULT;
                this.isRequesting = false;
                var success = result && (
                    (result.status == 200 && result.statusText == "OK" && !this.error)
                    || (result.status == '200')
                );
                if(success){
                    this.$store.dispatch('sendPasswordResetEmail', this.details.email);
                }
                return success;
            }
        },
    }

</script>